import { Box, Grid } from '@material-ui/core';
import { isNil } from '@roc/feature-utils';
import { Button, DialogState, Tabs, ConfirmDialog } from '@roc/ui';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { AddAttachmentDialog } from './addAttachmentDialog';
import { AttachmentPreview } from './attachmentPreview';
import { useState, useEffect } from 'react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { GeneralTaskType, TaskStatusDB, TaskV2, TaskV2Type } from '../../types/generalTasksTypes';
import { SummaryTab } from './editTaskBody/summaryTab';
import { CommentsTab } from './editTaskBody/commentsTab';
import { ESCALATED_TASK_TAG_TYPE, moveToRocCategories } from '../../utils/generalTasksConstants';
import { AppraisalSummaryTab } from './editTaskBody/appraisalSummaryTab';
import { useStore } from '@roc/client-portal-shared/hooks';
import { useUserStore } from '@roc/feature-app-core';
import { AppraisalCommentsTab } from './editTaskBody/appraisalCommentsTab';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerWrapperInternal: {
      overflow: 'auto',
      flexGrow: 1,
    },
    container: {
      width: '100%',
    },
    warningButton: {
      color: '#ff0000',
      borderColor: '#ff0000',
      marginRight: '8px',
    },
    additionalButton: {
      marginRight: '8px',
    },
  }),
);

export const MoveTaskToRocButton = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const store = editTaskStore;
  const classes = useStyles();
  const [moveToRocConfirmModalOpen, setMoveToRocConfirmModalOpenn] = useState(false);
  const { userStore } = useUserStore();

  const isValidMoveToRocCategory = (taskCategory: string) => {
    return moveToRocCategories.includes(taskCategory)
  }

  const handleMoveToRocConfirmAction = () => {
    store.moveTaskToRoc(() => {
      setMoveToRocConfirmModalOpenn(false);
      store.closeDialog();
    });
  }

  return (
    <div>
      {(store.dialogState === DialogState.EDIT &&
        isValidMoveToRocCategory(store.form.fields.taskType.value) &&
        store?.taskV2?.type2 == TaskV2Type.PROPERTY_ID && store?.taskV2?.typeId2 &&
        store?.taskV2?.type1 == TaskV2Type.LOAN_ID && store?.taskV2?.typeId1 &&
        userStore.isTamariskUser &&
        editTaskStore.taskV2?.category == GeneralTaskType.APPRAISAL_REPORT_REVIEW
      )
        &&
        <>
          <Button
            onClick={e => setMoveToRocConfirmModalOpenn(true)}
            className={classes.additionalButton}
            color="primary"
            variant="outlined"
            testId="moveToRoc"
          >
            Send to Roc
          </Button>
          <ConfirmDialog
            open={moveToRocConfirmModalOpen}
            confirmButtonText={'Yes'}
            cancelButtonText={'No'}
            handleClose={() => setMoveToRocConfirmModalOpenn(false)}
            handleCancel={() => setMoveToRocConfirmModalOpenn(false)}
            handleConfirm={handleMoveToRocConfirmAction}
            title={'Send to Roc?'}
            body={`Are you sure you want to send the task to the Roc team?`}
          />
        </>
      }
    </div>
  );
});

export const MarkTaskAsCompletedButton = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const store = editTaskStore;
  const classes = useStyles();
  const [confirmaModalOpen, setConfirmaModalOpen] = useState(false);
  const { userStore } = useUserStore();
  const { globalStore } = useStore();

  const isExternalPortal = globalStore.isCrmPortal || globalStore.isLenderPortal;
  const isExternalUser = userStore.isSalesUser || userStore.isLenderUser;

  const isValidCategory = (taskCategory: string) => {
    return moveToRocCategories.includes(taskCategory)
  }

  const getLoanId = (task: TaskV2) => {
    if (task !== null || task !== undefined) return null;
    if (task.type1 === 'LOAN_ID') return task.typeId1;
    if (task.type2 === 'LOAN_ID') return task.typeId2;

    return null;
  }

  const handleMarkAsCompletedConfirmAction = () => {
    if (isExternalPortal) {

      if (getLoanId(editTaskStore.taskV2) && editTaskStore?.taskV2?.status === TaskStatusDB.PENDING) {
        store.moveTaskToCapitalProvider(() => {
          setConfirmaModalOpen(false);
          store.closeDialog();
        });
      } else if (editTaskStore.taskV2?.category === GeneralTaskType.CMT_REVIEW) {
        store.moveTaskToCMTSpecialist(() => {
          setConfirmaModalOpen(false);
          store.closeDialog();
        });
      } else {
        store.moveTaskToRoc(() => {
          setConfirmaModalOpen(false);
          store.closeDialog();
        });
      }
    } else {
      store.markTaskAsCompletedV2(() => {
        setConfirmaModalOpen(false);
        store.closeDialog();
      });
    }

  }

  return (
    <div>
      {(store.dialogState === DialogState.EDIT && isExternalPortal && (
        (!editTaskStore?.isGeneralTask && editTaskStore?.taskV2?.status === TaskStatusDB.PENDING) || (
          isValidCategory(store.form.fields.taskType.value) &&
          store?.taskV2?.type2 == TaskV2Type.PROPERTY_ID && store?.taskV2?.typeId2 &&
          store?.taskV2?.type1 == TaskV2Type.LOAN_ID && store?.taskV2?.typeId1))
      )
        ?
        <>
          <Button
            onClick={e => setConfirmaModalOpen(true)}
            className={classes.additionalButton}
            color="primary"
            variant="outlined"
            testId="markAsCompleted"
          >
            {'Move Task To capital provider'}
          </Button>
          <ConfirmDialog
            open={confirmaModalOpen}
            confirmButtonText={'Yes'}
            cancelButtonText={'No'}
            handleClose={() => setConfirmaModalOpen(false)}
            handleCancel={() => setConfirmaModalOpen(false)}
            handleConfirm={handleMarkAsCompletedConfirmAction}
            title={'Move Task To capital provider?'}
            body={`Are you sure you want to move this task to capital provider?`}
          />
        </>
        :
        (store.dialogState === DialogState.EDIT &&
          isValidCategory(store.form.fields.taskType.value) &&
          store?.taskV2?.typeId2 &&
          store?.taskV2?.typeId1 &&
          (userStore.isUserAuthorizedToMarkAsComplete ||
            (userStore.isTamariskUser && editTaskStore.taskV2?.category === GeneralTaskType.APPRAISAL_REPORT_REVIEW) ||
            (globalStore.isInternalPortal && editTaskStore.taskV2?.category === GeneralTaskType.APPRAISAL_DOCUMENT_COLLECTION)
          )
        ) &&
        <>
          <Button
            onClick={e => setConfirmaModalOpen(true)}
            className={classes.additionalButton}
            color="primary"
            variant="outlined"
            testId="markAsCompleted"
          >
            {'Mark as completed'}
          </Button>
          <ConfirmDialog
            open={confirmaModalOpen}
            confirmButtonText={'Yes'}
            cancelButtonText={'No'}
            handleClose={() => setConfirmaModalOpen(false)}
            handleCancel={() => setConfirmaModalOpen(false)}
            handleConfirm={handleMarkAsCompletedConfirmAction}
            title={'Mark as completed?'}
            body={`Are you sure you want to mark this task as completed?`}
          />
        </>
      }
    </div>
  );
});

export const MarkTaskAsWaitingOnExternalButton = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const store = editTaskStore;
  const classes = useStyles();
  const [confirmaModalOpen, setConfirmaModalOpen] = useState(false);
  const { userStore } = useUserStore();
  const { globalStore } = useStore();

  const isExternalPortal = globalStore.isCrmPortal || globalStore.isLenderPortal;
  const isExternalUser = userStore.isSalesUser || userStore.isLenderUser;

  const isValidCategory = (taskCategory: string) => {
    return moveToRocCategories.includes(taskCategory)
  }

  const handleConfirm = () => {
    store.markTaskAsWaitingOnExternal(() => {
      setConfirmaModalOpen(false);
      store.closeDialog();
    });
  }

  return (
    <div>
      {(store.dialogState === DialogState.EDIT &&
        isValidCategory(store.form.fields.taskType.value) &&
        store?.taskV2?.typeId2 &&
        store?.taskV2?.typeId1 &&
        isExternalPortal
      )
        &&
        <>
          <Button
            onClick={e => setConfirmaModalOpen(true)}
            className={classes.additionalButton}
            color="primary"
            variant="outlined"
            testId="markAsWaitingOnExternal"
          >
            {'Mark Task As Waiting On Borrower'}
          </Button>
          <ConfirmDialog
            open={confirmaModalOpen}
            confirmButtonText={'Yes'}
            cancelButtonText={'No'}
            handleClose={() => setConfirmaModalOpen(false)}
            handleCancel={() => setConfirmaModalOpen(false)}
            handleConfirm={handleConfirm}
            title={'Mark task as waiting on borrower?'}
            body={`Are you sure you want to mark this task as waiting on borrower?`}
          />
        </>
      }
    </div>
  );
});

export const EscalateButton = observer(() => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const store = editTaskStore;
  const classes = useStyles();
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const taskId = store?.taskV2?.taskId;
  const isAlreadyEscalated =
    !isNil(store?.taskV2?.escalated) ||
    !!store?.taskV2?.taskTags?.some(tag => tag.tagType === ESCALATED_TASK_TAG_TYPE) ||
    generalTasksStore.isTaskEscalated(taskId);
  const canEscalate =
    store.dialogState === DialogState.EDIT &&
    !!taskId &&
    !isAlreadyEscalated &&
    store?.taskV2?.status !== TaskStatusDB.ACCEPTED;

  const handleCloseConfirmModal = () => setConfirmModalOpen(false);
  const handleConfirmAction = () => {
    generalTasksStore.escalateTask(taskId);
    setConfirmModalOpen(false);
  };

  return (
    <>
      {canEscalate &&
        <>
          <Button
            onClick={e => setConfirmModalOpen(true)}
            className={classes.warningButton}
            variant="outlined"
            testId="escalate"
          >
            Escalate
          </Button>
          <ConfirmDialog
            open={confirmModalOpen}
            confirmButtonText={'Yes'}
            cancelButtonText={'No'}
            handleClose={handleCloseConfirmModal}
            handleCancel={handleCloseConfirmModal}
            handleConfirm={handleConfirmAction}
            title={'Escalate task?'}
            body={`Are you sure you want to escalate this task?`}
          />
        </>
      }
    </>
  );
});

export const useEditGeneralTask = () => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const store = editTaskStore;
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    setSelectedTabIndex(0);
  }, [store.dialogState]);

  const getTitle = () => {
    const taskId = generalTasksStore?.editTaskStore?.taskV2?.taskId;
    const parentTaskId = store.form.fields.parentTaskId.value;

    if (store.dialogState === DialogState.EDIT) {
      return `Task #${taskId}`;
    } else if (store.dialogState === DialogState.ADD && parentTaskId) {
      return 'Subtask';
    } else {
      return `Task`;
    }
  };

  const TABS = [{ label: 'SUMMARY' }, { label: 'COMMENTS' }];

  const onTabChange = (e, index) => {
    setSelectedTabIndex(index);
    if (index === 1 && editTaskStore.dialogState === DialogState.EDIT && !editTaskStore?.hasConversation) {
      editTaskStore.createTaskChatRoom();
    }
    if (index === 0 && editTaskStore.dialogState === DialogState.EDIT) {
      editTaskStore.reloadTaskById(generalTasksStore.editTaskStore.taskV2.taskId);
    }
  };

  return {
    store,
    classes,
    selectedTabIndex,
    setSelectedTabIndex,
    getTitle,
    TABS,
    onTabChange,
  };
};

export const TaskDialogContent = observer(({ selectedTabIndex, onTabChange, classes, showTabs = true }) => (
  <Box my={1} className={classes.container}>
    <Grid container spacing={4} className={classes.container} style={{ paddingTop: 0 }}>
      {showTabs ?
        <>
          <Grid item xs={12} md={12}>
            <Tabs tabs={[{ label: 'SUMMARY' }, { label: 'COMMENTS' }]} selectedTab={selectedTabIndex} onTabChange={onTabChange} />
          </Grid>
          {selectedTabIndex === 0 && <SummaryTab />}
          {selectedTabIndex === 1 && <CommentsTab />}
        </> :
        <SummaryTab />
      }
      <AttachmentPreview />
      <AddAttachmentDialog />
    </Grid>
  </Box>
));

export const useEditAppraisalTask = () => {
  const { generalTasksStore } = useGeneralTasksStore();
  const { editTaskStore } = generalTasksStore;
  const store = editTaskStore;
  const { globalStore } = useStore();
  const { userStore } = useUserStore();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    setSelectedTabIndex(0);
  }, [store.dialogState, globalStore.isLenderPortal, globalStore.isCrmPortal]);

  const getTitle = () => {
    const taskId = generalTasksStore?.editTaskStore?.taskV2?.taskId;
    const parentTaskId = store.form.fields.parentTaskId.value;

    if (store.dialogState === DialogState.EDIT) {
      return `Task #${taskId}`;
    } else if (store.dialogState === DialogState.ADD && parentTaskId) {
      return 'Subtask';
    } else {
      return 'Task';
    }
  };

  const TABS = [
    { label: 'SUMMARY' },
    { label: 'COMMENTS' },
  ];

  const onTabChange = (e: React.ChangeEvent<{}>, index: number) => {
    setSelectedTabIndex(index);
    if (
      index === 1 &&
      editTaskStore.dialogState === DialogState.EDIT &&
      !editTaskStore?.hasConversation
    ) {
      if (editTaskStore?.taskV2?.category === GeneralTaskType.APPRAISAL_REPORT_REVIEW) {
        editTaskStore.createTaskChatRoom();
      } else {
        editTaskStore.setHasConversation(true);
      }
    }
    if (index === 0 && editTaskStore.dialogState === DialogState.EDIT) {
      editTaskStore.reloadTaskById(editTaskStore.taskV2?.taskId);
    }
  };

  return { store, classes, selectedTabIndex, getTitle, TABS, onTabChange, globalStore };
};

export const AppraisalTaskContent = observer(({ selectedTabIndex, onTabChange, classes, store, globalStore, showTabs = true }) => (
  <Box my={1} className={classes.container}>
    <Grid container spacing={4} className={classes.container} style={{ paddingTop: 0 }}>
      {showTabs ?
        <>
          <Grid item xs={12} md={12}>
            <Tabs tabs={[{ label: 'SUMMARY' }, { label: 'COMMENTS' }]} selectedTab={selectedTabIndex} onTabChange={onTabChange} />
          </Grid>
          {selectedTabIndex === 0 && <AppraisalSummaryTab />}
          {selectedTabIndex === 1 &&
            (store?.taskV2?.category == GeneralTaskType.APPRAISAL_REPORT_REVIEW
              ? globalStore.isInternalPortal
                ? store.isTamariskAppraisal
                  ? <CommentsTab />
                  : <AppraisalCommentsTab />
                : <AppraisalCommentsTab />
              : <AppraisalCommentsTab />)}
        </>
        : <AppraisalSummaryTab />}
    </Grid>
  </Box>
));